module.exports = __webpack_public_path__ + "static/media/dotedLine.9e28b9bd.svg";